<p-toast></p-toast>
<div class="animated fadeIn">
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="field-space-btwn">
            <div class="mt-4">
              <form [formGroup]="addItemForm">
                <formly-form [model]="model" [fields]="fields" [options]="options" (modelChange)="modelChange()" [form]="addItemForm"></formly-form>
              </form>
              <div class="mt-4 text-right">
                <button
                  label="Cancel"
                  pButton
                  type="button"
                  icon="pi pi-times"
                  iconPos="left"
                  (click)="triggerCancel()"
                  class="p-button-danger mr-2"
                ></button>

                <button
                  label="Save"
                  pButton
                  type="button"
                  icon="pi pi-plus"
                  iconPos="left"
                  (click)="createOrUpdateItem(addItemForm)"
                  [disabled]="!addItemForm.valid"
                  [loading]="isSubmiting"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
